//#region types

/**
 * 乗務員マスタ_基本データ型定義
 */
export type TZyomuinMasterBase = Partial<{
  入社年月日: string | null | undefined
  生年月日: string | null | undefined
  性別区分ID?: number
  性別区分コード: string
  性別区分名称1: string
  性別区分ソート番号?: number
  血液型区分ID?: number
  血液型区分コード: string
  血液型区分名称1: string
  血液型区分ソート番号?: number

  選任日: string | null | undefined
  選任種類: string

  郵便番号: string
  住所: string
  電話番号: string
  携帯電話番号: string
  メールアドレス: string

  緊急連絡先: string
  緊急連絡先番号: string
  携帯アドレス: string

  社員カードID: string
  入社区分ID: number
  入社区分コード: string
  入社区分名称1: string
  入社区分ソート番号?: number
  退職年月日: string | null | undefined
  退職フラグ?: number
  退職事由: string
  備考: string
}>

/**
 * 乗務員マスタ_免許情報型定義
 */
export type TMenkyoJoho = Partial<{
  免許取得日: string | null | undefined
  免許証番号: string
  免許大型フラグ: number
  免許中型フラグ: number
  免許普通フラグ: number
  免許大特フラグ: number
  免許大自二フラグ: number
  免許普自二フラグ: number
  免許小特フラグ: number
  免許原付フラグ: number
  免許け引フラグ: number
  免許大二フラグ: number
  免許中二フラグ: number
  免許普二フラグ: number
  免許大特二フラグ: number
  免許け引二フラグ: number
  免許条件1: string
  免許条件2: string
  免許条件3: string

  運転記録最終取得日: string | null | undefined
  SDカード色: string
  無事故年数?: number
  その他手当?: number

  Has顔写真AtStart: boolean
  顔写真?: TPictureFile
}>

/**
 * 画像ファイル
 */
export type TPictureFile = {
  isNewFile: boolean
  row_id: string
  ファイルURL: string
  ファイル名: string
}

//#endregion

//#region

/**
 * 車輌マスタ_車検証 初期値
 */
export const initialSyakenSyoState: TZyomuinMasterBase = {}

/**
 * 車両マスタ 基準緩和　初期値
 */
export const initialMenkyoJohoState: TMenkyoJoho = {}

//#endregion
